import axios from 'axios';
import { showLoader, hideLoader, setLoaderController } from '../helper/LoaderUtility';
import { AuthContext, } from '../auth/AuthContext';
import { useContext } from 'react';
import { toast } from 'react-toastify';

// const { clearAuth } = useContext(AuthContext);

const APIClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL, //'http://localhost:5000',
  withCredentials: true
});

// Create a loader element and update utility
const loaderElement = document.createElement('div');
document.body.appendChild(loaderElement);
const updateLoader = (isVisible) => {
  loaderElement.style.display = isVisible ? 'block' : 'none';
};
setLoaderController(updateLoader);

// Request interceptor
APIClient.interceptors.request.use(
  (config) => {
    showLoader();
    console.log('Intercept:Request started:', config);
    return config;
  },
  (error) => {
    hideLoader();
    console.log('Intercept:Request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
APIClient.interceptors.response.use(
  (response) => {
    hideLoader();
    console.log('Intercept:Response received');
    return response;
  },
  (error) => {
    hideLoader();
    
    if(error.code != "ERR_NETWORK"){
      console.log('Intercept:Response error :: ' + error.response.data.message);
      if(error.response.data && error.response.data === 'Forbidden' || error.response.data.message && error.response.data.message === 'No token, authorization denied'){
        localStorage.removeItem('userInfo');
      }
      // toast.error(error.response.data.message, {
      //   position: "bottom-center",
      //   pauseOnHover: true,
      //   delay: true
      // });
    }
    return Promise.reject(error);
  }
);

export default APIClient;